import React, { useState } from "react";
import { postEventApplication_4 } from "../Api";
import PropTypes from "prop-types";

export default function EventApplication(props) {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [region, setRegion] = useState("");
    const [regionOthers, setRegionOthers] = useState("");
    const [open_quiz_1, setOpen_quiz_1] = useState(""); // Alt number
    const [open_quiz_2, setOpen_quiz_2] = useState(""); // Age
    const [open_quiz_3, setOpen_quiz_3] = useState(""); // Feeling

    const [open_quiz_4, setOpen_quiz_4] = useState([]); // Kids age groups
    const [open_quiz_5, setOpen_quiz_5] = useState([]); // Allergies
    const [message_quiz_1, setMessage_quiz_1] = useState(""); // allergies specify

    const [message_quiz_2, setMessage_quiz_2] = useState("");
    const [message_quiz_3, setMessage_quiz_3] = useState("");
    const [message_quiz_4, setMessage_quiz_4] = useState([]);
    const [message_quiz_5, setMessage_quiz_5] = useState("");
    const [message_quiz_6, setMessage_quiz_6] = useState("");
    const [message_quiz_7, setMessage_quiz_7] = useState("");
    const [message_quiz_8, setMessage_quiz_8] = useState("");

    const [open_quiz_6, setOpen_quiz_6] = useState([]);
    const [open_quiz_7, setOpen_quiz_7] = useState("");
    const [open_quiz_8, setOpen_quiz_8] = useState([]);
    const [open_quiz_9, setOpen_quiz_9] = useState([]);
    const [open_quiz_10, setOpen_quiz_10] = useState("");
    const [open_quiz_11, setOpen_quiz_11] = useState([]);
    const [open_quiz_12, setOpen_quiz_12] = useState("");
    const [open_quiz_13, setOpen_quiz_13] = useState([]);
    const [open_quiz_14, setOpen_quiz_14] = useState("");

    // Validation errors
    const [errors, setErrors] = useState({});

    // const handleCheckboxChange = (setFunc) => (event) => {
    //     const { value, checked } = event.target;
    //     setFunc((prev) => checked ? [
    //         ...prev,
    //         value
    //     ] : prev.filter((item) => item !== value));
    //     // Clear error when user selects at least one option
    //     if (checked) {
    //         const fieldName = event.target.name;
    //         setErrors((prev) => ({
    //             ...prev,
    //             [fieldName]: null
    //         }));
    //     }
    // };

    const handleRadioChange = (setFunc) => (event) => {
        setFunc(event.target.value);
        // Clear error when user selects an option
        const fieldName = event.target.name;
        setErrors((prev) => ({
            ...prev,
            [fieldName]: null
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        // Required fields validation
        if (!name)
            newErrors.name = "Name is required";


        if (!phone)
            newErrors.phone = "Phone number is required";


        if (!region)
            newErrors.region = "Region is required";


        if (!open_quiz_1)
            newErrors.open_quiz_1 = "Field is required";

        if (!open_quiz_2)
            newErrors.open_quiz_2 = "Field is required";


        // if (open_quiz_3.length === 0)
        //     newErrors.open_quiz_3 = "Please select at least one option";


        // if (!message_quiz_2)
        //     newErrors.message_quiz_2 = "This field is required";

        // if (!message_quiz_3)
        //     newErrors.message_quiz_3 = "This field is required";



        // Conditional validations
        // if (region === "Other" && !regionOthers) {
        //     newErrors.regionOthers = "Please specify your region";
        // }
        // if (open_quiz_3.includes("Other/Tell us more") && !message_quiz_1) {
        //     newErrors.message_quiz_1 = "Please provide details";
        // }
        // if (open_quiz_6.includes("Other (please specify)") && !message_quiz_3) {
        //     newErrors.message_quiz_3 = "Please provide details";
        // }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validate form before submission
        if (!validateForm()) { // Scroll to the first error
            const firstErrorField = document.querySelector(".error-message");
            if (firstErrorField) {
                firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
        }

        setLoading(true);

        const data = {
            title: props?.title,
            phone: phone,
            name: name,
            residency: region,
            residency_other: regionOthers,
            open_quiz_1: open_quiz_1,
            open_quiz_2: open_quiz_2,
            open_quiz_3: open_quiz_3,
            open_quiz_4: open_quiz_4.join(", "),
            open_quiz_5: open_quiz_5.join(", "),
            message_quiz_1: message_quiz_1,
            message_quiz_2: message_quiz_2,
            message_quiz_3: message_quiz_3,
            message_quiz_4: message_quiz_4.join(", "),
            message_quiz_5: message_quiz_5,
            message_quiz_6: message_quiz_6,
            message_quiz_7: message_quiz_7,

            message_quiz_8: message_quiz_8,

            open_quiz_6: open_quiz_6.join(", "),
            open_quiz_7: open_quiz_7,
            open_quiz_8: open_quiz_8.join(", "),
            open_quiz_9: open_quiz_9.join(", "),
            open_quiz_10: open_quiz_10,
            open_quiz_11: open_quiz_11.join(", "),
            open_quiz_12: open_quiz_12,
            open_quiz_13: open_quiz_13.join(", "),
            open_quiz_14: open_quiz_14
        };

        console.log(data);
        console.log(`submittind data, ${data}`)
        postEventApplication_4(data).then((msg) => {
            setName("");
            setPhone("");
            setRegion("");
            setRegionOthers("");
            setOpen_quiz_1("");
            setOpen_quiz_2("");
            setOpen_quiz_3("");
            setOpen_quiz_4([]);
            setOpen_quiz_5([]);
            setOpen_quiz_6([]);
            setOpen_quiz_7("");
            setOpen_quiz_8([]);
            setOpen_quiz_9("");
            setOpen_quiz_10("");
            setOpen_quiz_11([]);
            setOpen_quiz_12("");
            setOpen_quiz_13([]);
            setOpen_quiz_14("");
            setMessage_quiz_1("");
            setMessage_quiz_2("");
            setMessage_quiz_3("");
            setMessage_quiz_4("");
            setMessage_quiz_5("");
            setMessage_quiz_6("");
            setMessage_quiz_7("");

            setMessage_quiz_8("");

            setLoading(false);
            if (msg !== false) {
                setSuccess(true);
                props.onFormSubmitSuccess();
            }
        });
    };

    // Helper component for error messages
    const ErrorMessage = ({ error }) => {
        if (!error)
            return null;


        return <div className="error-message text-danger mt-1">
            {error}</div>;
    };
    ErrorMessage.propTypes = {
        error: PropTypes.string
    };

    return (
        <div style={
            {
                width: "100%",
                minHeight: "60vh",
                maxWidth: 800,
                backgroundColor: !success ? "#e5e5e5" : "white",
                padding: 10,
                borderRadius: 10
            }
        }>
            {
                success === false && (
                    <form onSubmit={handleSubmit}>
                        <h4>Personal Details</h4>

                        {/* Name */}
                        <div className="form-group">
                            <label htmlFor="name" className="required">
                                1. Full Name
                            </label>
                            <input value={name}
                                onChange={
                                    (e) => {
                                        setName(e.target.value);
                                        setErrors((prev) => ({
                                            ...prev,
                                            name: null
                                        }));
                                    }
                                }
                                type="text"
                                className={
                                    `form-control ${errors.name ? "is-invalid" : ""
                                    }`
                                }
                                id="name"
                                placeholder="Enter your Full name" />
                            <ErrorMessage error={
                                errors.name
                            } />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone" className="required">
                                2. Mobile Phone Number
                            </label>
                            <input value={phone}
                                onChange={
                                    (e) => {
                                        setPhone(e.target.value);
                                        setErrors((prev) => ({
                                            ...prev,
                                            phone: null
                                        }));
                                    }
                                }
                                type="text"
                                className={
                                    `form-control ${errors.phone ? "is-invalid" : ""
                                    }`
                                }
                                id="phone"
                                placeholder="Enter your phone number" />
                            <ErrorMessage error={
                                errors.phone
                            } />
                        </div>


                        {/* Region */}
                        <div className="form-group">
                            <label htmlFor="region" className="required">
                                4. Home Address/Region
                            </label>
                            <select className={
                                `form-control ${errors.region ? "is-invalid" : ""
                                }`
                            }
                                id="region"
                                value={region}
                                onChange={
                                    (e) => {
                                        setRegion(e.target.value);
                                        setErrors((prev) => ({
                                            ...prev,
                                            region: null
                                        }));
                                    }
                                }>
                                <option value="">-- --</option>
                                {
                                    [
                                        [
                                            "Githurai_44", "Githurai 44"
                                        ],
                                        [
                                            "Githurai_45", "Githurai 45"
                                        ],
                                        [
                                            "Roysambu/Mirema", "Roysambu/Mirema"
                                        ],
                                        [
                                            "Zimmerman", "Zimmerman"
                                        ],
                                        [
                                            "Kahawa_West", "Kahawa West"
                                        ],
                                        [
                                            "Kahawa_Wendani", "Kahawa Wendani"
                                        ],
                                        [
                                            "Kasarani", "Kasarani"
                                        ],
                                        [
                                            "Hunters", "Hunters"
                                        ],
                                        [
                                            "Mwiki", "Mwiki"
                                        ],
                                        [
                                            "Sunton", "Sunton"
                                        ],
                                        [
                                            "Lucky_Summer/Baba_Dogo/Ngumba", "Lucky Summer/Baba Dogo/Ngumba",
                                        ],
                                        [
                                            "kariobangi", "Kariobangi"
                                        ],
                                        [
                                            "Mowlem_Umoja_3", "Mowlem/Umoja 3"
                                        ],
                                        [
                                            "Umoja", "Umoja"
                                        ],
                                        [
                                            "Pipeline", "Pipeline"
                                        ],
                                        [
                                            "Kayole", "Kayole"
                                        ],
                                        [
                                            "Kibera", "Kibera"
                                        ],
                                        [
                                            "Outer_Road", "Outering Road"
                                        ],
                                        [
                                            "Dandora", "Dandora"
                                        ],
                                    ].map(([value, label]) => (
                                        <option key={value}
                                            value={value}>
                                            {label} </option>
                                    ))
                                }
                                <option value="Other">Other</option>
                            </select>
                            <ErrorMessage error={
                                errors.region
                            } />
                        </div>

                        {
                            region === "Other" && (
                                <div className="form-group">
                                    <label htmlFor="regionOthers">
                                        Specify region if `Other` is selected
                                    </label>
                                    <input value={regionOthers}
                                        onChange={
                                            (e) => {
                                                setRegionOthers(e.target.value);
                                                setErrors((prev) => ({
                                                    ...prev,
                                                    regionOthers: null
                                                }));
                                            }
                                        }
                                        type="text"
                                        className={
                                            `form-control ${errors.regionOthers ? "is-invalid" : ""
                                            }`
                                        }
                                        id="regionOthers"
                                        placeholder="Enter your region" />
                                    <ErrorMessage error={
                                        errors.regionOthers
                                    } />
                                </div>
                            )
                        }

                        <div className="form-group">
                            <label htmlFor="open_quiz_1" className="required">4. Your Favourite EPL Team?</label>

                            <input type="text"
                                id="open_quiz_1"
                                name="open_quiz_1"
                                value={open_quiz_1}
                                onChange={(e) => setOpen_quiz_1(e.target.value)}

                                placeholder="Enter your Favourite team"
                                className={
                                    `form-control ${errors.open_quiz_1 ? "is-invalid" : ""
                                    }`
                                } />
                            <ErrorMessage error={
                                errors.open_quiz_1
                            } />

                        </div>

                        <div className="form-group">
                            <label htmlFor="open_quiz_2" className="required">5. Predict the total number of goals scored across all EPL matches in the opening weekend</label>

                            <input type="text"
                                id="open_quiz_2"
                                name="open_quiz_2"
                                value={open_quiz_2}
                                onChange={(e) => setOpen_quiz_2(e.target.value)}

                                placeholder="Total Number of goals to be scored"
                                className={
                                    `form-control ${errors.open_quiz_2 ? "is-invalid" : ""
                                    }`
                                } />
                            <ErrorMessage error={
                                errors.open_quiz_2
                            } />

                        </div>
                        <div className="form-group">
                            <label className="required">
                                6.Have you downloaded the Konnect App?
                            </label>
                            <div className={
                                errors.open_quiz_3 ? "is-invalid" : ""
                            }>
                                {
                                    ["Yes", "No",].map((option) => (
                                        <div key={option}>
                                            <input type="radio" className="input_test"
                                                id={
                                                    `open_quiz_3_${option.replace(/\s+/g, "_")
                                                    }`
                                                }
                                                name="open_quiz_3"
                                                value={option}
                                                checked={
                                                    open_quiz_3 === option
                                                }
                                                onChange={
                                                    handleRadioChange(setOpen_quiz_3)
                                                } />
                                            <label htmlFor={
                                                `open_quiz_3_${option.replace(/\s+/g, "_")
                                                }`
                                            }>
                                                {option} </label>
                                            <br />
                                        </div>
                                    ))
                                } </div>
                            <ErrorMessage error={
                                errors.open_quiz_3
                            } />

                        </div>

                        {/* <div className="form-group">
                            <label className="required">
                                5. What has been the most rewarding part of your fatherhood journey?
                            </label>
                            <div className={
                                errors.message_quiz_4 ? "border border-danger rounded p-2" : ""
                            }>
                                {
                                    [
                                        "Watching them overcome challenges and knowing I played a part in  helping them grow",
                                        "Knowing that no matter how tough life gets, I matter to someone more than anything else",
                                        "The small moments - helping with homework, bedtime stories, early morning cuddles",
                                        "Being called 'Dad'-it hits me every time",
                                        "Being their safe place. Knowing they trust me - that's everything",
                                        "Watching my kids grow into kind, respectful people. Thats the real reward",
                                        "Other/Tell us more",
                                    ].map((option) => (
                                        <div key={option}>
                                            <input type="checkbox" className="input_test"
                                                id={
                                                    `message_quiz_4_${option.replace(/\s+/g, "_")
                                                    }`
                                                }
                                                name="message_quiz_4"
                                                value={option}
                                                checked={
                                                    message_quiz_4.includes(option)
                                                }
                                                onChange={
                                                    handleCheckboxChange(setMessage_quiz_4)
                                                } />
                                            <label htmlFor={
                                                `message_quiz_4_${option.replace(/\s+/g, "_")
                                                }`
                                            }>
                                                {option} </label>
                                            <br />
                                        </div>
                                    ))
                                } </div>
                            <ErrorMessage error={
                                errors.message_quiz_4
                            } /> {
                                message_quiz_4.includes("Other/Tell us more") && (
                                    <>
                                        <textarea type="text"
                                            className={
                                                `form-control mt-2 ${errors.message_quiz_1 ? "is-invalid" : ""
                                                }`
                                            }
                                            placeholder="Please tell us more"
                                            id="message_quiz_1"
                                            name="message_quiz_1"
                                            value={message_quiz_1}
                                            onChange={
                                                (e) => {
                                                    setMessage_quiz_1(e.target.value);
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        message_quiz_1: null
                                                    }));
                                                }
                                            } />
                                        <ErrorMessage error={
                                            errors.message_quiz_1
                                        } />
                                    </>
                                )
                            } </div> */}
                        {/* 

                        <div className="form-group">
                            <label className="required">
                                6. What has been one of your biggest lessons or challenges as a father? Your story may inspire another dad.
                            </label>
                            <br />
                            <textarea className={
                                `form-control ${errors.message_quiz_2 ? "is-invalid" : ""
                                }`
                            }
                                id="message_quiz_2"
                                value={message_quiz_2}
                                onChange={
                                    (e) => {
                                        setMessage_quiz_2(e.target.value);
                                        setErrors((prev) => ({
                                            ...prev,
                                            message_quiz_2: null
                                        }));
                                    }
                                }
                                rows={3} />
                            <ErrorMessage error={
                                errors.message_quiz_2
                            } />
                        </div> */}

                        {/* <div className="form-group">
                            <label className="required">
                                7. Would you be open to having your story shared (anonymously or with your name) during the celebration?
                            </label>
                            <div className={
                                errors.open_quiz_3 ? "is-invalid" : ""
                            }>
                                {
                                    ["Yes,  you can share the story with my name", "Yes,but keep it anonymous", "No, I prefer to keep it private",].map((option) => (
                                        <div key={option}>
                                            <input type="radio" className="input_test"
                                                id={
                                                    `open_quiz_3_${option.replace(/\s+/g, "_")
                                                    }`
                                                }
                                                name="open_quiz_3"
                                                value={option}
                                                checked={
                                                    open_quiz_3 === option
                                                }
                                                onChange={
                                                    handleRadioChange(setOpen_quiz_3)
                                                } />
                                            <label htmlFor={
                                                `open_quiz_3_${option.replace(/\s+/g, "_")
                                                }`
                                            }>
                                                {option} </label>
                                            <br />
                                        </div>
                                    ))
                                } </div>
                            <ErrorMessage error={
                                errors.open_quiz_3
                            } />

                        </div> */}

                        {/* <div className="form-group">
                            <label className="required">
                                8. What do you enjoy doing to relax or recharge? We’d love to create an experience that feels good to you.
                            </label>
                            <br />
                            <textarea type="text"
                                className={
                                    `form-control mt-2 ${errors.message_quiz_3 ? "is-invalid" : ""
                                    }`
                                }
                                placeholder="Please tell us more"
                                id="message_quiz_3"
                                name="message_quiz_3"
                                value={message_quiz_3}
                                onChange={
                                    (e) => {
                                        setMessage_quiz_3(e.target.value);
                                        setErrors((prev) => ({
                                            ...prev,
                                            message_quiz_3: null
                                        }));
                                    }
                                } />
                            <ErrorMessage error={
                                errors.message_quiz_3
                            } />


                        </div> */}



                        {/* Submit button */}
                        <div style={
                            { float: "right" }
                        }>
                            {
                                loading ? (
                                    <button type="button" className="btn btn-warning">
                                        Loading...
                                    </button>
                                ) : (
                                    <button type="submit" className="btn btn-warning">
                                        Submit Survey
                                    </button>
                                )
                            } </div>
                    </form>
                )
            }
            {
                success && (
                    <div style={
                        {
                            textAlign: "center",
                            padding: "20px"
                        }
                    }>
                        <div className="alert alert-success" role="alert">
                            <p className="font-bold">EPL NA KONNECT USIKOSE MECHI</p>
                            <p>We&apos;ve received your EPL week one&apos;s predictions.</p>
                            <p>Winners will be announced on Tuesday Morning</p>


                        </div>

                        <div style={
                            {
                                margin: "20px 0",
                                fontStyle: "italic",
                                color: "#555"
                            }
                        }>
                            Dimba na Konnect GOOD LUCK
                        </div>

                        <div style={
                            {
                                display: "flex",
                                justifyContent: "center",
                                gap: "10px",
                                marginTop: "20px",
                                flexWrap: "wrap"
                            }
                        }>
                            <a href="https://play.google.com/store/apps/details?id=net.sasakonnect.supper_app&pcampaignid=web_share" target="_blank" rel="noopener noreferrer"
                                style={
                                    {
                                        padding: "10px 20px",
                                        backgroundColor: "#0000FF",
                                        color: "white",
                                        textDecoration: "none",
                                        borderRadius: "5px",
                                        fontWeight: "500"
                                    }
                                }>
                                DOWNLOAD OUR APP
                            </a>
                            <a href="https://karibu.sasakonnect.net" target="_blank" rel="noopener noreferrer"
                                style={
                                    {
                                        padding: "10px 20px",
                                        backgroundColor: "#4ECDC4",
                                        color: "white",
                                        textDecoration: "none",
                                        borderRadius: "5px",
                                        fontWeight: "500"
                                    }
                                }>
                                RETURN HOME
                            </a>
                        </div>
                        <div style={
                            {
                                marginTop: "30px",
                                padding: "15px",
                                backgroundColor: "#e4edf2",
                                borderRadius: "10px"
                            }
                        }>
                            <p style={
                                {
                                    color: "#08306b",
                                    marginBottom: "5px"
                                }
                            }>
                                BEST!
                            </p>
                            <p style={
                                {
                                    fontSize: "0.9rem",
                                    color: "#888"
                                }
                            }>
                                From all of us at Konnect
                            </p>
                        </div>
                    </div>
                )
            } </div>
    );
}

EventApplication.propTypes = {
    title: PropTypes.string.isRequired, // Validate that `title` is a required string
    onFormSubmitSuccess: PropTypes.func.isRequired
};

